import React, { useEffect } from 'react';

import ReflectionCalendar from './ReflectionCalendar';

import './ReflectionModal.css';

const ReflectionModal = ({ isOpen, onClose }) => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  // Detect sidebar state by checking for sidebar element
  useEffect(() => {
    if (!isOpen) return;

    const checkSidebar = () => {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        const isOpen = sidebar.classList.contains('open');
        setIsSidebarOpen(isOpen);
      }
    };

    // Check immediately
    checkSidebar();

    // Set up observer to watch for sidebar changes
    const observer = new MutationObserver(checkSidebar);
    const sidebar = document.querySelector('.sidebar');

    if (sidebar) {
      observer.observe(sidebar, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    return () => observer.disconnect();
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      className={`reflection-modal-backdrop ${isSidebarOpen ? 'sidebar-open' : ''}`}
      onClick={handleBackdropClick}
    >
      <div className={`reflection-modal ${isSidebarOpen ? 'blurred' : ''}`}>
        <div className="reflection-modal-header">
          <h2>
            <i className="fa-solid fa-book-open" /> Reflection
          </h2>
          <button
            type="button"
            className="reflection-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <i className="fa-solid fa-times" />
          </button>
        </div>
        <div className="reflection-modal-content">
          <ReflectionCalendar />
        </div>
      </div>
    </div>
  );
};

export default ReflectionModal;
